import {
    SET_ACTIVE_LINK,
    SET_BOX_PARAMS,
    TOGGLE_BOX,
    TOGGLE_PAYMENT_EDIT,
    USER_UPDATED
} from "../redux/reducers/layout";
import {Dispatch} from "react";
import {RESET_CHANGE_PASSWORD} from "../redux/reducers/changePasswordForm";
import {User} from "../redux/reducers/user";

export const TOGGLE_USER_EDIT = 'TOGGLE_USER_EDIT';
export const TOGGLE_EDIT_PASSWORD = 'TOGGLE_EDIT_PASSWORD';
export const SET_SIDEBAR_TOGGLE_MOBILE =
    'THEME_OPTIONS/SET_SIDEBAR_TOGGLE_MOBILE';
export const SET_SIDEBAR_FIXED = 'THEME_OPTIONS/SET_SIDEBAR_FIXED';
export const SET_SIDEBAR_TOGGLE = 'THEME_OPTIONS/SET_SIDEBAR_TOGGLE';
export const SET_SIDEBAR_HOVER = 'THEME_OPTIONS/SET_SIDEBAR_HOVER';
export const EDIT_CASE = 'EDIT_CASE';

export const toggleUserEdit = (userEdit: User | boolean) => {
    return (dispatch: Dispatch<object | boolean>) => {
        if (userEdit) {
            dispatch({type: 'SET_USER_EDIT_FORM', payload: userEdit});
        }
        return dispatch({type: TOGGLE_USER_EDIT});
    }
};

export const toggleChangePassword = () => {
    return (dispatch: any) => {
        return dispatch({type: TOGGLE_EDIT_PASSWORD});
    }
};

export const togglePaymentEdit = () => {
    return (dispatch: Dispatch<object>) => {
        return dispatch({type: TOGGLE_PAYMENT_EDIT})
    }
};

export const resetPasswordForm = () => {
    return (dispatch: Dispatch<object>) => {
        return dispatch({type: RESET_CHANGE_PASSWORD})
    }
};

export const setSidebarFixed = (sidebarFixed: any) => ({
    type: SET_SIDEBAR_FIXED,
    sidebarFixed
});

export const setSidebarToggleMobile = (sidebarToggleMobile: any) => ({
    type: SET_SIDEBAR_TOGGLE_MOBILE,
    sidebarToggleMobile
});

export const setSidebarToggle = (sidebarToggle: any) => ({
    type: SET_SIDEBAR_TOGGLE,
    sidebarToggle
});

export const setSidebarHover = (sidebarHover: any) => ({
    type: SET_SIDEBAR_HOVER,
    sidebarHover
});

export const setActiveLink = (activeLink: any) => ({
    type: SET_ACTIVE_LINK,
    activeLink
});

export const editCase = (action: boolean) => ({
    type: EDIT_CASE,
    action
});

export const resetUnsubscribe = () => ({
    type: 'UNSUBSCRIBE',
    action: undefined
});

export const userUpdated = (payload: boolean) => ({
    type: USER_UPDATED,
    payload
});

export const setBoxParams = (data: any) => ({
    type: SET_BOX_PARAMS,
    data
});

export const toggleBox = (data: any) => ({
    type: TOGGLE_BOX,
    data
});
